import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "land-plot-modal-top" }
const _hoisted_2 = { class: "land-plot-modal-top__slider" }
const _hoisted_3 = {
  key: 1,
  class: "land-plot-modal-top__slider-placeholder"
}
const _hoisted_4 = { class: "land-plot modal-top__info" }
const _hoisted_5 = { class: "land-plot-modal-top__info-title" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "land-plot-modal-top__info-title-hl" }
const _hoisted_8 = {
  key: 0,
  class: "land-plot-modal-top__info-description"
}
const _hoisted_9 = { class: "land-plot-modal-top__info-promotion" }
const _hoisted_10 = { class: "land-plot-modal-top__info-promotion-title" }
const _hoisted_11 = { class: "land-plot-modal-top__info-promotion-main" }
const _hoisted_12 = { class: "land-plot-modal-top__info-promotion" }
const _hoisted_13 = { class: "land-plot-modal-top__info-promotion-title" }
const _hoisted_14 = { class: "land-plot-modal-top__info-promotion-title-text" }
const _hoisted_15 = { class: "land-plot-modal-top__info-promotion-main" }
const _hoisted_16 = {
  key: 1,
  class: "land-plot-modal-top__info-price"
}
const _hoisted_17 = {
  key: 0,
  class: "land-plot-modal-top__info-price-set"
}
const _hoisted_18 = {
  key: 0,
  class: "land-plot-modal-top__info-price-set"
}
const _hoisted_19 = {
  key: 1,
  class: "land-plot-modal-top__info-price-set"
}
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "land-plot-modal-top__info-price-value" }
const _hoisted_22 = {
  key: 2,
  class: "land-plot-modal-top__info-price-set"
}
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "land-plot-modal-top__info-price-value" }
const _hoisted_25 = {
  key: 2,
  class: "land-plot-modal-top__info-additional"
}
const _hoisted_26 = { class: "land-plot-modal-top__info-additional-txt text-ll text-simple-light ff-raleway" }
const _hoisted_27 = { class: "land-plot-modal-top__info-actions" }
const _hoisted_28 = {
  key: 3,
  class: "land-plot-modal-top__info-cadastral"
}
const _hoisted_29 = { class: "land-plot-modal-top__info-cadastral-number" }

import { computed, ref, onMounted } from 'vue';
import { cardSettingsStore } from '@/store/modules/CardSettings';
import CustomButton from '@/components/commons/CustomControls/CustomButton.vue';
import CustomList from '@/components/commons/CustomList.vue';
import PercentIcon from '@/components/commons/icons/PercentIcon.vue';
import GiftIcon from '@/components/commons/icons/GiftIcon.vue';
import SliderGallery from '@/components/slider/SliderGallery.vue';
import ChevronLeftIcon from '@/components/commons/icons/ChevronLeftIcon.vue';
import LandStatus from '@/components/commons/LandStatus.vue';
import { cashSpacer } from '@/helpers/cashHelpers';
import { switchCostLabel } from '@/helpers/costHelpers';
import { ILandPlot } from '@/types/LandPLot';
import { CustomListItem } from '@/types/common/CustomList';

const BOOK_BUTTON_SELECTOR = '[href="#popup:book"]';


export default /*@__PURE__*/_defineComponent({
  __name: 'LandPlotModalTop',
  props: {
    landPlot: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

function formatedCost(price: number) {
    return cashSpacer(price, ' ');
}

const cadastralNumber = computed(() => {
    let result = props.landPlot.plot.cadastralNumber;
    const isNumber = /\d/.test(result);

    if (!isNumber) {
        result = '';
    }

    return result;
});

const listTop = computed<Array<CustomListItem>>(() => {
    const result = [
        {
            id: -1,
            title: 'Площадь участка,  соток',
            text: props.landPlot.plot.area
                ? props.landPlot.plot.area.toString()
                : '',
        },
        ...(props.landPlot.house?.area
            ? [
                {
                    id: -2,
                    title: 'Общая площадь дома, м²',
                    text: props.landPlot.house?.area
                        ? props.landPlot.house.area.toString()
                        : '',
                },
            ]
            : []),
    ];

    if (props.landPlot.house)
        props.landPlot.house.out.forEach(i =>
            result.push({
                id: i.id,
                title: i.name,
                text: i.value,
            }),
        );
    if (
        props.landPlot &&
        props.landPlot.plot &&
        props.landPlot.plot.parameters &&
        props.landPlot.plot.parameters.length
    )
        props.landPlot.plot.parameters.forEach(param => {
            if (param.name === 'Срок сдачи' && param.value) {
                result.push({
                    id: param.id || 0,
                    title: param.name,
                    text: param.value,
                });
            }
        });

    return result;
});

const isSold = computed(() => {
    return (
        (!props.landPlot.plot.cost && !props.landPlot.plot.newCost) ||
        props.landPlot.plot.status === 'occupied'
    );
});

function onBookButtonClick() {
    cardSettingsStore.LAND_PLOT_CARD_IN_MODAL_SET_SHOW_STATUS(false);

    const popupEl = document.querySelector(
        '[data-tooltip-hook="#popup:book"]',
    );

    if (!popupEl) return;

    const {
        plot: { houseNumber, name },
    } = props.landPlot;

    const houseInputEl = popupEl.querySelector(
        'input[name="house_number"]',
    ) as HTMLInputElement | null;
    const projectInputEl = popupEl.querySelector(
        'input[name="project_name"]',
    ) as HTMLInputElement | null;
    const actionInputEl = popupEl.querySelector(
        'input[name="action_name"]',
    ) as HTMLInputElement | null;

    if (houseInputEl) {
        houseInputEl.value = houseNumber || '';
    }

    if (projectInputEl) {
        projectInputEl.value = name || '';
    }

    if (actionInputEl) {
        actionInputEl.value = 'Забронировать';
    }
}

function openCadastralPage() {
    if (!cadastralNumber.value) return;
    const text = cadastralNumber.value.replace(/:/g, '%3A');
    const opened = cadastralNumber.value
        .split(':')
        .map(item => {
            if (item.startsWith('0')) item = item.substring(1);
            return item;
        })
        .join('%3A');
    const url = `https://pkk.rosreestr.ru/#/search/?text=${text}&type=1&opened=${opened}&inPoint=true`;

    window.open(url, '_blank');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.landPlot.plot && _ctx.landPlot.plot.images.length)
        ? (_openBlock(), _createBlock(SliderGallery, {
            key: 0,
            images: _ctx.landPlot.plot.images,
            mode: "plot"
          }, null, 8, ["images"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3)),
      _createVNode(LandStatus, {
        class: "land-plot-modal-top__status",
        landPlotStatus: _ctx.landPlot.plot.status
      }, null, 8, ["landPlotStatus"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h2", _hoisted_5, [
        (_ctx.landPlot.house)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Проект "))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.landPlot.plot.name), 1),
        _createTextVNode(_toDisplayString(props.landPlot.plot.street.name
                            ? `, ${props.landPlot.plot.street.name}`
                            : '') + _toDisplayString(_ctx.landPlot.plot.houseNumber
                        ? `, ${_ctx.landPlot.plot.houseNumber}`
                        : ''), 1)
      ]),
      (_ctx.landPlot.house)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.landPlot.house.descriptionOut), 1))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_9, [
        _createElementVNode("h3", _hoisted_10, [
          _createVNode(GiftIcon, { class: "land-plot-modal-top__info-promotion-icon" }),
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "land-plot-modal-top__info-promotion-title-text" }, " Акция", -1))
        ]),
        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.landPlot.plot.action), 1)
      ], 512), [
        [_vShow, _ctx.landPlot.plot.action &&
                !(_ctx.landPlot.plot.status === 'occupied')
                ]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_12, [
        _createElementVNode("h3", _hoisted_13, [
          _createVNode(PercentIcon, { class: "land-plot-modal-top__info-promotion-icon" }),
          _createElementVNode("span", _hoisted_14, " Скидка " + _toDisplayString(_ctx.landPlot.plot.discount.value) + "%", 1)
        ]),
        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.landPlot.plot.discount.description), 1)
      ], 512), [
        [_vShow, _ctx.landPlot.plot.discount.value]
      ]),
      (isSold.value || _ctx.landPlot.plot.cost || _ctx.landPlot.plot.newCost)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            (isSold.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[2] || (_cache[2] = [
                  _createElementVNode("div", { class: "land-plot-modal-top__info-price-value land-plot-modal-top__info-price-value--sold" }, " Продано ", -1)
                ])))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.landPlot.plot.cost && _ctx.landPlot.plot.cost === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[3] || (_cache[3] = [
                        _createElementVNode("div", { class: "land-plot-modal-top__info-price-value" }, " Скоро в продаже ", -1)
                      ])))
                    : _createCommentVNode("", true),
                  (_ctx.landPlot.plot.cost && _ctx.landPlot.plot.cost !== 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", {
                          class: "land-plot-modal-top__info-price-label",
                          innerHTML: `Цена с ${_unref(switchCostLabel)(_ctx.landPlot.plot.cost, [
                            `<b
                                >чистовой отделкой</b
                            >`,
                            `отделкой <b>Black box</b>`,
                        ])}`
                            
                        }, null, 8, _hoisted_20),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(`${formatedCost(_ctx.landPlot.plot.cost)} ₽`), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.landPlot.plot.newCost)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", {
                          class: "land-plot-modal-top__info-price-label",
                          innerHTML: `Цена с ${_unref(switchCostLabel)(
                            _ctx.landPlot.plot.newCost,
                            [
                                `<b
                                >чистовой отделкой</b
                            >`,
                                `отделкой <b>White box</b>`,
                            ],
                        )}`
                            
                        }, null, 8, _hoisted_23),
                        _createElementVNode("div", _hoisted_24, _toDisplayString(`${formatedCost(_ctx.landPlot.plot.newCost || 0)} ₽`), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
          ]))
        : _createCommentVNode("", true),
      (_ctx.landPlot.plot.additional)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.landPlot.plot.additional), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(CustomButton, {
          disabled: isSold.value ? 'disabled' : null,
          size: "lg",
          theme: "warning",
          tag: "a",
          href: "#popup:book",
          "aria-haspopup": "dialog",
          onClick: onBookButtonClick
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode("Забронировать")
          ])),
          _: 1
        }, 8, ["disabled"])
      ]),
      (cadastralNumber.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _cache[5] || (_cache[5] = _createElementVNode("p", { class: "land-plot-modal-top__info-cadastral-label" }, " Кадастровый номер ", -1)),
            _createElementVNode("p", {
              class: "land-plot-modal-top__info-cadastral-value",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (openCadastralPage()))
            }, [
              _createElementVNode("span", _hoisted_29, _toDisplayString(cadastralNumber.value), 1),
              _createVNode(ChevronLeftIcon, { class: "land-plot-modal-top__info-cadastral-icon" })
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(CustomList, {
        list: listTop.value,
        theme: "odd"
      }, null, 8, ["list"])
    ])
  ]))
}
}

})